import { MutuosARecaudar } from "../../../endosos/endososPsm/models/mutuosARecaudar";
import { FiltroGeneracionSIIIndividual, FiltroGeneracionSIIMasivo } from "../models/filtroGeneracionSII";
import { generarCertificadosSIIIndividual, generarCertificadosSIIMasivo } from "../services/certificadoService";

export default function UseCertificadoSII() {

    const generarCertificadoIndividual = async (filtroGeneracion: FiltroGeneracionSIIIndividual) => {
        const response = await generarCertificadosSIIIndividual(filtroGeneracion);
        return response;
    }

    const generarCertificadoMasivo = async (filtroGeneracion: FiltroGeneracionSIIMasivo) => {
        const response = await generarCertificadosSIIMasivo(filtroGeneracion);
        return response;
    }

    return {generarCertificadoIndividual, generarCertificadoMasivo}
}